module.exports = __webpack_public_path__ + "img/title1.6c9e9144.png";